import type { BadgeTokens } from './types';

export const badge: BadgeTokens = {
  colors: {
    text: 'neutral.0',
    bg: 'blue.50',
  },
  space: {
    mr: '-16px', // TODO: try to use the space tokens defined in figma
    p: '1px 0 0', // TODO: try to use the space tokens defined in figma
  },
  transform: {
    base: 'translate(-50%, -50%)',
  },
};
